import {FileTypesPath} from "../components/email/AttachmentList";
import {ContentType} from "./ContentTypes";

export type ContentTransferEncodingType = "base64" | "quoted-printable" | "7bit";

export function getAttachmentImageSource(contentType: string): string {
    let type = "unknown";
    if (contentType.startsWith("text/")) {
        type = "txt";
    } else if (contentType.startsWith("image/")) {
        type = "image";
    } else if (contentType.startsWith("application/pdf")) {
        type = "pdf";
    } else if (contentType.startsWith("audio/")) {
        type = "audio";
    } else if (contentType.startsWith("video/")) {
        type = "video";
    } else if (contentType.startsWith("application/msword") || contentType.startsWith("application/vnd.openxmlformats-officedocument.wordprocessingml")) {
        type = "document";
    } else if (contentType.startsWith("application/vnd.ms-excel") || contentType.startsWith("application/vnd.openxmlformats-officedocument.spreadsheetml")) {
        type = "spreadsheet";
    } else if (contentType.startsWith("application/vnd.microsoft.portable-executable")) {
        type = "exe";
    } else if (contentType.startsWith("application/zip")) {
        type = "zip";
    } else if (contentType.startsWith("application/pgp-keys")) {
        type = "security";
    } else if (contentType.startsWith(ContentType.EmailMessage)) {
        type = "mail-icon-64";
    } else if (contentType) {
        console.log("Unrecognised mime type", contentType);
    }

    // TODO: add more content types here as required
    return FileTypesPath + type + ".png";
}

export function replaceImageUrlsWithContentIds(text: string): string {
    // E.g. <img src="data:image/png;base64,iVBORw0KGgoAA" alt="ed6be348-c02d-4543-bc8e-fc986bc86e23"/>
    const matches = text.matchAll(/src="data:[^;]+;base64,[^"]+"\W+alt="([0-9a-fA-F-]+)"/g);
    for (const match of matches) {
        text = text.replace(match[0], `src="cid:${match[1]}"`);
    }
    return text;
}

export function createTrackingImage(trackingImageId: string): string {
    return `<img src="https://jrlh.co.uk/Mail/ContactImage.aspx?uuid=${trackingImageId}" alt=""/>`;
}

export function uint8ArrayToBase64(uint8Array: Uint8Array): string {
    if (typeof (uint8Array as any).toBase64 === 'function') {
        return (uint8Array as any).toBase64();
    } else {
        // Fallback for browsers that do not support toBase64
        const binaryString = String.fromCharCode(...uint8Array);
        return btoa(binaryString);
    }
}
